export const STOK_TIPI_LABEL = {
  oz: 'Öz',
  konsinye: 'Konsinye',
};

export const formatCerideAdet = (adet) => {
  const n = Number(adet);
  if (!Number.isFinite(n) || n === 0) return '0';
  return n > 0 ? `+${n}` : String(n);
};

export const cerideAdetClass = (adet) => {
  const n = Number(adet);
  if (n > 0) return 'stok-ceride__adet--giris';
  if (n < 0) return 'stok-ceride__adet--cikis';
  return 'stok-ceride__adet--sifir';
};
